import { render, staticRenderFns } from "./TextInputForm.vue?vue&type=template&id=7242804e&scoped=true&"
import script from "./TextInputForm.vue?vue&type=script&lang=js&"
export * from "./TextInputForm.vue?vue&type=script&lang=js&"
import style0 from "./TextInputForm.vue?vue&type=style&index=0&id=7242804e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7242804e",
  null
  
)

export default component.exports